import { useMemo } from 'react';
import styled from 'styled-components';
import OverviewSection from '../overviewSection';
import SubRTableView from '../../SubRTableView';
import { formatDateWithTimezoneOffset } from '../../../../../helpers/utils';
import NoDataUI from '../NoDataUI';

interface ITableViewSectionProps {
  currentReportWidget: string;
  contentData: any;
  value: string;
}

const TableViewSection = ({ contentData, value }: ITableViewSectionProps) => {
  const transformedData = useMemo(() => {
    const rawData = contentData?.data ?? [];

    if (!rawData.length) return null;

    const firstRow = rawData[0];
    const timezoneOffset = firstRow?.offset;
    const timestampValue = firstRow?.date;

    // Transform data by adding serial numbers
    const tableData = rawData.map((row: any, index: number) => ({
      ...row,
      sr_no: index + 1
    }));

    return {
      subHeading: {
        label: 'Location: ',
        value: firstRow.location || ''
      },
      overview: {
        details: [
          {
            label: 'Date',
            value: formatDateWithTimezoneOffset(
              timestampValue?.toString(),
              timezoneOffset,
              'dd MMM yyyy, hh:mm:ss aa'
            )
          },
          {
            label: 'Created By',
            value: firstRow.created_by || '-'
          },
          {
            label: 'Updated By',
            value: firstRow.updated_by || '-'
          },
          {
            label: 'Completed By',
            value: firstRow.completed_by || '-'
          },
          {
            label: 'Reconciled By',
            value: firstRow.reconciled_by || '-'
          }
        ],
        summary: {
          label: 'Comments',
          value: firstRow.comments || ''
        }
      },
      table: {
        columns: [
          {
            header: 'Sr. No',
            accessor: 'sr_no'
          },
          {
            header: 'Inventory Category',
            accessor: 'inventory_item_category_name'
          },
          {
            header: 'Inventory Items',
            accessor: 'inventory_items'
          },
          {
            header: 'Unit Name',
            accessor: 'unit_name'
          },
          {
            header: 'Closing Stock',
            accessor: 'closing_stock'
          },
          {
            header: 'Closing Stock Value',
            accessor: 'closing_stock_value'
          },
          {
            header: 'Counted Stock',
            accessor: 'counted_stock'
          },
          {
            header: 'Counted Stock Value',
            accessor: 'counted_stock_value'
          },
          {
            header: 'Stock Difference',
            accessor: 'stock_diff',
            formatType: 'negative'
          },
          {
            header: 'Cost Difference',
            accessor: 'cost_diff',
            formatType: 'negative'
          }
        ],
        data: tableData
      }
    };
  }, [contentData]);

  if (!transformedData) {
    return (
      <Wrapper>
        <NoDataUI />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div style={{ width: '100%', height: '100%' }}>
        <OverviewSection
          overviewData={transformedData.overview}
          location={transformedData.subHeading}
          reportId={value}
        />
        <SubRTableView
          data={{
            ...transformedData.table,
            config: contentData.config
          }}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`;

export default TableViewSection;
